import { useEffect, useMemo } from 'react';
import { useAutomationRulesService } from '../../services';

export const useAutomationRulesBadge = () => {
	const { fetch, error, loading, data } = useAutomationRulesService();

	const automationRulesCount = useMemo(() => {
		if (!data?.total) return 0;
		return data.total;
	}, [data]);

	useEffect(() => {
		fetch();
	}, [fetch]);

	return { fetch, error, loading, automationRulesCount: error ? 0 : automationRulesCount };
};
